import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import { Link } from 'react-router-dom';
import { useState, useEffect }from 'react'
import dot from 'assets/blue_dot.png'
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'
import { ChevronDownIcon } from '@heroicons/react/20/solid'
import axios from 'axios';


  //PONE AL CENTRO DEL MAPA LA UBICACION DEL USUARIO
  function ChangeView({center}){
    const map = useMap();

    useEffect(()=>{
      map.setView(center)
    }, [center])

    return null
  }

  //PRINCIPAL
  export default function TripList({
    evento,
    loading,
    slug
  }) {

    const config = {
      headers: {
          'Accept': 'application/json'
      }
    };
        
    //------------------------- OBTENEMOS LA UBICACION DEL USUARIO -------------------------
    const [position, setPosition] = useState([40.444071, -3.690899]);
    const [permiso, setPermiso] = useState(false);

    const getUserLocation = () => {
      if ("geolocation" in navigator) {
          navigator.geolocation.getCurrentPosition(
              (pos) => {
                  const lat = pos.coords.latitude;
                  const lon = pos.coords.longitude;
                  setPosition([lat, lon]);
                  setPermiso(true);
              },
              (error) => {
                  setPermiso(false);
              },
              { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
          );
      } else {
          setPermiso(false);
      }
    };

    useEffect(() => {
      getUserLocation();
    }, []);

    //---------------------- SI CAMBIA EL MAPA, ACTUALIZA LOS LIMITES Y OBTENEMOS NUEVOS TRIPS -------------------------
    const [trips, setTrips] = useState([])
    const [isLoadingTrips, setIsLoadingTrips] = useState(false)
    const [bounds, setBounds] = useState({
      southWest: { lat: 0, lng: 0 },
      northEast: { lat: 0, lng: 0 }
    });


    const HandleMapMovement = () => {
      const map = useMap();
  
      useEffect(() => {
        const onMoveEnd = () => {
          const bounds = map.getBounds();
          const southWest = bounds.getSouthWest();
          const northEast = bounds.getNorthEast();

          setBounds({
            southWest: { lat: southWest.lat, lng: southWest.lng },
            northEast: { lat: northEast.lat, lng: northEast.lng }
          });

        };
  
        map.on('moveend', onMoveEnd); 
        map.on('zoomend', onMoveEnd); 

        return () => {
          map.off('moveend', onMoveEnd);
          map.off('zoomend', onMoveEnd);
        };
      }, [map]);
  
      return null;
    };
  
    useEffect(() => {
      const get_trips = async () => {
        try {
            setIsLoadingTrips(true)
            const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/trip/by_event?slug=${slug}&sw_lat=${bounds.southWest.lat}&sw_lng=${bounds.southWest.lng}&ne_lat=${bounds.northEast.lat}&ne_lng=${bounds.northEast.lng}`, config);
            if (res.status === 200) {
                setTrips(res.data.results.trips)
            } else {
                setTrips([])
            }
        } catch (err) {
          setTrips([])
        } finally {
          setIsLoadingTrips(false)
        }
      }
      get_trips()
    }, [bounds]);

    //------------------------------- ORDER_BY --------------------------------------------
    const [hoveredTripId, setHoveredTripId] = useState(null);
    const [sortCriteria, setSortCriteria] = useState({ criteria: '', order: '' });
    const [sortOrderSeats, setSortOrderSeats] = useState(null);
    const [sortOrderHora, setSortOrderHora] = useState(null);

    const sortTrips = ({ criteria, order }) => {
      if (!criteria) return trips;
      
      const sortedTrips = [...trips].sort((a, b) => {
        let comparison = 0;
        switch (criteria) {
          case 'available_seats':
            comparison = a.available_seats - b.available_seats;
            break;
          case 'pickup_time':
            comparison = a.pickup_time.localeCompare(b.pickup_time);
            break;
          default:
            return 0;
        }
        
        return order === 'asc' ? comparison : -comparison;
      });
    
      return sortedTrips;
    };

    const toggleSortOrderSeats = () => {

      let newSortOrder;
      if (sortOrderSeats === null) {
        newSortOrder = 'asc';
        setSortCriteria({ criteria: 'available_seats', order: 'asc' });
      } else if (sortOrderSeats === 'asc') {
        newSortOrder = 'desc';
        setSortCriteria({ criteria: 'available_seats', order: 'des' });
      } else {
        newSortOrder = null;
        setSortCriteria({ criteria: '', order: '' });
      }
      setSortOrderSeats(newSortOrder);
      setSortOrderHora(null);
    };

    const toggleSortOrderHora = () => {

      let newSortOrder;
      if (sortOrderHora === null) {
        newSortOrder = 'asc';
        setSortCriteria({ criteria: 'pickup_time', order: 'asc' });
      } else if (sortOrderHora === 'asc') {
        newSortOrder = 'desc';
        setSortCriteria({ criteria: 'pickup_time', order: 'des' });
      } else {
        newSortOrder = null;
        setSortCriteria({ criteria: '', order: '' });
      }
      setSortOrderHora(newSortOrder);
      setSortOrderSeats(null);
    };
    
    const sortedTrips = sortTrips(sortCriteria);

    //MARCADORES

    const customMarkerIcon = L.divIcon({
      html: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
              <path strokeLinecap="round" strokeLinejoin="round" d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
              <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z" />
            </svg>
            `,
      className: "text-blue-green",
      iconSize: [32, 32],
      iconAnchor: [16, 32],
      popupAnchor: [0, -32]
    });

    const customHoverMarkerIcon = L.divIcon({
      html: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="size-8">
                <path fill-rule="evenodd" d="m11.54 22.351.07.04.028.016a.76.76 0 0 0 .723 0l.028-.015.071-.041a16.975 16.975 0 0 0 1.144-.742 19.58 19.58 0 0 0 2.683-2.282c1.944-1.99 3.963-4.98 3.963-8.827a8.25 8.25 0 0 0-16.5 0c0 3.846 2.02 6.837 3.963 8.827a19.58 19.58 0 0 0 2.682 2.282 16.975 16.975 0 0 0 1.145.742ZM12 13.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" clip-rule="evenodd" />
              </svg>
            `,
      className: "text-blue-green",
      iconSize: [32, 32],
      iconAnchor: [16, 32],
      popupAnchor: [0, -32]
    });
   
    const customMarkerYou = L.icon({
      iconUrl: dot,
      iconSize: [32, 32],
      iconAnchor: [16, 32],
      popupAnchor: [0, -32]
    });

    //FORMATEO FECHA
    const formatFecha = (fecha) => {
      if (!fecha) return '';

      const date = new Date(fecha);
      const options = { day: 'numeric', month: 'short' };

      return date.toLocaleDateString('es-ES', options);
    }

    return (
      <div className='flex-1'>

      {/* HEADER */}
      <section
            className="relative rounded-3xl m-4 overflow-hidden bg-cover bg-opacity-75 bg-top " style={{ backgroundImage: `url(${evento&&evento.thumbnail})` }}
      >
            <div className="absolute inset-0 bg-black bg-opacity-70"></div>
            <div className="relative mt-24 pb-10">
              <h2 className="text-7xl ml-10 font-bold tracking-tight text-white">{evento&&evento.title}</h2>
              <p className="mt-2 text-xl leading-8 text-white ml-10">
              {evento?.recinto?.name}, {evento?.ciudad?.name}
              </p>
            </div>
            <div className="absolute top-0 right-0 p-10 text-white text-4xl flex flex-col items-center">
              {evento&&formatFecha(evento.fecha)}
            </div>
      </section>

      {/* CONTENIDO */}
      <div className="m-5">
        <div className="mx-auto max-w-full">
          <div className="grid md:grid-cols-5 h-[80vh]">

            {/* LISTADO */}
            <div className="order-2 md:order-1 md:col-span-3 overflow-y-auto md:px-10" style={{ 
                  scrollbarWidth: "none",
                  msOverflowStyle: "none"
                }}>
                {sortedTrips && sortedTrips.length > 0 ? (
                  <>
                  <div className='sticky top-0 flex justify-between items-center bg-gray-50 w-full pt-5 pb-7 z-10'>
                    <h2 className=" text-lg leading-7 font-bold text-black">Se encontraron {trips.length} viajes en esta zona</h2>
                    <Menu as="div" className="relative text-left">
                        <div>
                          <MenuButton className="inline-flex w-full justify-center gap-x-1.5 rounded-3xl border bg-white px-3 py-2 text-sm font-semibold text-black shadow-sm hover:bg-gray-50">
                            Ordenar
                            <ChevronDownIcon aria-hidden="true" className="-mr-1 h-5 w-5 text-gray-400" />
                          </MenuButton>
                        </div>

                        <MenuItems
                          transition
                          className="absolute right-0 z-10 mt-2 w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                        >
                          <div className="py-1">
                            <MenuItem>
                              <button
                                onClick={toggleSortOrderSeats}
                                className="block w-full px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 flex items-center space-x-2"
                              >
                                Plazas disponibles
                                {sortOrderSeats === 'asc' && (
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-4">
                                  <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 6.75 12 3m0 0 3.75 3.75M12 3v18" />
                                </svg>
                                )}
                                {sortOrderSeats === 'desc' && (
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-4">
                                  <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 17.25 12 21m0 0-3.75-3.75M12 21V3" />
                                </svg>
                                )}
                              </button>
                            </MenuItem>
                          </div>
                          <div className="py-1">
                            <MenuItem>
                              <button
                                onClick={toggleSortOrderHora}
                                className="block w-full px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 flex items-center space-x-2"
                              >
                                Hora Salida
                                {sortOrderHora === 'asc' && (
                                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-4">
                                  <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 6.75 12 3m0 0 3.75 3.75M12 3v18" />
                                  </svg>
                                )}
                                {sortOrderHora === 'desc' && (
                                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-4">
                                  <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 17.25 12 21m0 0-3.75-3.75M12 21V3" />
                                  </svg>
                                )}
                              </button>
                            </MenuItem>
                          </div>
                        </MenuItems>
                    </Menu>
                  </div>

                  <div className="w-full flex flex-col gap-y-4">
                  {sortedTrips.map((trip, index) => (
                    <Link 
                      to={`/trip/${trip.slug}`} 
                      key={index} 
                      className={`rounded-3xl bg-white transition-all shadow-sm duration-500 border-2 hover:border-blue-green`}
                      onMouseEnter={() => setHoveredTripId(trip.id)}
                      onMouseLeave={() => setHoveredTripId(null)}
                    >
                      <div className="p-6">

                          <div className="flex items-center justify-between">
                            <h3 className="text-2xl font-semibold leading-6 text-gray-900">
                              {trip.pickup_time.slice(0, 5)}
                            </h3>
                            <div className="flex items-center gap-x-4 text-xs">
                              <time className="text-gray-500">
                                  A 4km de ti
                              </time>
                            </div>
                          </div>

                          <h3 className="mt-3 text-md font-md leading-6 text-gray-900">
                            {trip.pickup_location.address}
                          </h3>

                          <div className="relative mt-3 w-full flex items-center gap-x-4">
                            <img alt="Conductor" src={`${trip?.creator?.profile_picture}`} className="h-10 w-10 rounded-full bg-gray-50" />
                            <div className="w-full text-sm leading-6 flex justify-between items-center  ">
                                <div>
                                  <p className="text-gray-800">{trip.creator.first_name}</p>
                                  <p className="text-gray-600 text-xs -mt-1">Conductor</p>
                                </div>
                                <p className="font-bold text-gray-600">
                                  Plazas disponibles: 
                                  <span> {trip.available_seats} </span>
                                </p>
                            </div>
                          </div>
                      </div>
                    </Link>
                  ))}
                  </div>
                  
                  <div className='mt-4'>
                      {/* <PaginationTrips page_function={get_trips_list_by_event_location_page} count={count} bounds={bounds}/> */}
                  </div>
               
                  </>
                ):
                <div className='my-20 flex flex-col items-center'>
                    <h2 className="text-3xl leading-7 font-bold text-black mb-4">No se encontraron viajes en esta zona.</h2>
                    <h2 className="text-md leading-7 text-gray-900">Desplazate por el mapa para descubrir nuevas zonas. </h2>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="my-5 h-20 w-20">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M9 6.75V15m6-6v8.25m.503 3.498 4.875-2.437c.381-.19.622-.58.622-1.006V4.82c0-.836-.88-1.38-1.628-1.006l-3.869 1.934c-.317.159-.69.159-1.006 0L9.503 3.252a1.125 1.125 0 0 0-1.006 0L3.622 5.689C3.24 5.88 3 6.27 3 6.695V19.18c0 .836.88 1.38 1.628 1.006l3.869-1.934c.317-.159.69-.159 1.006 0l4.994 2.497c.317.158.69.158 1.006 0Z" />
                    </svg>
                </div>
                }
            </div>

            {/* MAPEADO */}
            <div className="order-1 md:order-2 md:col-span-2 rounded-3xl overflow-hidden">
              <MapContainer center={position} zoom={14} className="h-full w-full" style={{ position: "relative", zIndex: 1}} >
                <TileLayer
                    url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"
                />

                <ChangeView center={position}/>
                <HandleMapMovement />

                {permiso && (
                    <Marker position={position} icon={customMarkerYou}></Marker>
                )}

                {trips&&trips.map((trip, index) => (
                    <Marker
                      key={index} 
                      position={[trip.pickup_location.latitude, trip.pickup_location.longitude]} 
                      icon={hoveredTripId === trip.id ? customHoverMarkerIcon : customMarkerIcon}
                      eventHandlers={{
                        mouseover: () => {
                          setHoveredTripId(trip.id);
                        },
                        mouseout: () => {
                          setHoveredTripId(null);
                        },
                      }}
                    >

                        <Popup minWidth={100} maxWidth={200}>
                        <Link 
                          to={`/trip/${trip.slug}`} 
                          className={`flex max-w-xl flex-col items-start justify-between bg-gray-50 rounded border shadow`}
                        >
                        <div className="p-6">
                          <div className="group relative">
                            <h3 className="text-xl font-semibold leading-6 text-gray-900">
                              <span className="font-normal">Salida:</span> {trip.pickup_time.slice(0, 5)}
                            </h3>
                            <h3 className="mt-2 text-lg font-semibold leading-6 text-gray-900">
                              <span className="font-normal text-xl">Desde:</span> {trip.pickup_location.address}
                            </h3>
                            <p className="mt-3 relative z-10 rounded-full font-medium text-gray-600">
                              Plazas disponibles: 
                              <span
                                className={`ml-1 px-2 py-1 rounded-full text-black ${
                                  trip.available_seats > 2
                                    ? 'bg-green-200'
                                    : trip.available_seats === 2
                                    ? 'bg-amber-200'
                                    : 'bg-red-200'
                                }`}
                              >
                                {trip.available_seats}
                              </span>
                            </p>
                          </div>
                        </div>
                        </Link>
                        </Popup>
                    </Marker>
                ))}
              </MapContainer>
            </div>
          </div>          
        </div>
      </div>
      <div className='h-10'></div>
      </div>
    )
  }